import useProfiler from "hooks/useProfiler";
import { createMicroConversionTrackingUtils } from "..";

const utils = createMicroConversionTrackingUtils({
  name: "flights_web_flexible_ticket_icon",
  stages: {
    sr: 1, // SR fully loaded + non-empty (and fallback from main)
    main: 2, // any card that has flexible ticket is in viewport
    direct: 3,
    metaClosedFD: 4, // on meta, when user closes FD and lands back on SR
    metaSRinBackground: 5, // - when they are on FD, SR on background (learning only)
    oneWay: 5,
    roundTrip: 6,
    us: 7,
    families: 8
  },
  defaultStage: 1,
  mainStage: 2,
  goals: {
    popoverTriggered: 1 // how many people hover over the icons set
  },
  goalsWithValue: []
});

export const useTrackFlexIcon = (flexCardIsInViewport: boolean) => {
  const stages = utils.stages;
  const { isDirect, isOneWay, isAmerican, isFamily } = useProfiler();
  if (flexCardIsInViewport) {
    utils.stages.main();
    isDirect() && stages.direct();
    isOneWay() ? stages.oneWay() : stages.roundTrip();
    isAmerican() && stages.us();
    isFamily() && stages.families();
  }
};

export default utils;
